export const PARTS_SEARCH = 'partsSearch';
export const PARTS_MANUAL = 'partsManual';
export const MANUAL_APPROVAL_MESSAGE = 'isManualApprovalMessageViewed';
export const EQUIPMENT_VALUE = 'equipmentValue';
export const REQUEST_BY_DATE = 'requestByDate';
export const CONSENT = 'consent';
export const LOGON_USER_COOKIE = 'WC_LogonUserId_';
export const QUICK_ORDER_SAVED_ITEMS = 'catSavedQOItems';
export const RCLIST = 'rclist';
export const IS_GUEST = 'isGuest';
export const WC_GUEST_SESSION = 'WC_GUEST_SESSION';
export const QSI_HISTORY_SESSION = 'QSI_HistorySession';
